__turbopack_context__.v({
  "label": "lb5YmW_label",
  "switch": "lb5YmW_switch",
  "thumb": "lb5YmW_thumb",
  "track": "lb5YmW_track",
});
